const mutations = {
  /**
   * Sets AppMessage on the AppMessageView.
   */
  view(state, { componentName, message }) {
    const { defaults } = state
    const normalizedMessage = { ...defaults, ...message }
    const allMessagesForView = state.views[componentName] || []

    allMessagesForView.push(normalizedMessage)

    state.views = { ...state.views, [componentName]: allMessagesForView }
  },
}

export default mutations
